import React from "react";
import PropTypes from "prop-types";
import ReviewSummaryItem from "./components/ReviewSummaryItem";
import "./ReviewSummaryList.scss";

const ReviewSummaryList = ({ review, isTemplate, handleClick, refetchMyReviews }) => (
  <div className="summary-container">
    {review?.evaluations?.map((evaluation) => (
      <ReviewSummaryItem
        evaluation={evaluation}
        handleClick={handleClick}
        isTemplate={isTemplate}
        refetchMyReviews={refetchMyReviews}
      />
    ))}
  </div>
);

ReviewSummaryList.propTypes = {
  review: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  isTemplate: PropTypes.bool,
  refetchMyReviews: PropTypes.func,
};

ReviewSummaryList.defaultProps = {
  isTemplate: false,
  refetchMyReviews: null,
};

export default ReviewSummaryList;
